import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'next-i18next';
import getFixedOptionsByPackage from '../../../../../src/utils/booking/getFixedOptionsByPackage';

// Icons
import InfoIcon from '../../../../../public/icons/info_inverted.svg';

function WarningFixedOptions({
  pack, allExtras, locale,
}) {
  const { t } = useTranslation();

  return (
    allExtras && Object.values(allExtras) && getFixedOptionsByPackage(
      pack,
      Object.values(allExtras)?.filter((extra) => !extra.product?.archived),
      locale,
    )?.length ? (
      <InfoIcon
        style={{ fill: '#fff', minWidth: '20px' }}
        className="flex center text-c-primary c-pointer m-l-10"
        data-tip={t(
          `booking.choice.stage.${getFixedOptionsByPackage(
            pack,
            Object.values(allExtras),
            locale,
          ).length > 1
            ? 'fixedOptions'
            : 'fixedOption'}`,
          {
            options: getFixedOptionsByPackage(pack, Object.values(allExtras), locale).join(', '),
          },
        )}
        data-for="warningCampFixedOptions"
      />
      ) : null
  );
}

WarningFixedOptions.propTypes = {
  allExtras: PropTypes.shape({}),
  locale: PropTypes.string,
};

WarningFixedOptions.defaultProps = {
  allExtras: null,
  locale: null,
};

export default WarningFixedOptions;
